import VText from './index.vue';

export {
  VText,
};

export default VText;
